import { FC, useEffect, useState } from "react";
import useEvent from "react-use-event-hook";

import { StationHubItemDisplay } from "./station-hub-item.display";
import { StationHubItemEdit } from "./station-hub-item.edit";
import { IStationHubItem } from "./table-station-hub.models";

interface IStationHubRowProps {
  item: IStationHubItem;
  existingItems?: IStationHubItem[];
  currentStationId?: number;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
  onRemove: (item: IStationHubItem) => void;
  onUpdated: (prevValue: IStationHubItem, newValue: IStationHubItem) => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

export const StationHubRow: FC<IStationHubRowProps> = ({
  item,
  existingItems = [],
  currentStationId,
  disabledEdit,
  disabledRemove,
  onRemove,
  onUpdated,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  const handleEditClick = useEvent(() => {
    setInEdit(true);
  });

  const handleRemove = useEvent(() => {
    onRemove(item);
  });

  const handleCancel = useEvent(() => {
    setInEdit(false);
  });

  const handleSubmit = useEvent((newItem: IStationHubItem) => {
    handleCancel();
    onUpdated(item, newItem);
  });

  return (
    <>
      {!inEdit && (
        <StationHubItemDisplay
          item={item}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
          onRemove={handleRemove}
          onEditClick={handleEditClick}
        />
      )}

      {inEdit && (
        <StationHubItemEdit
          value={item}
          existingItems={existingItems}
          currentStationId={currentStationId}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};
